<template>
  <Modal title="审核" v-model="isShow" @on-cancel="handle">
    <div class="myModal">
        <Form ref="formInfo"  :model='formInfo' label-position="right" :label-width="120" :rules="ruleValidate" @submit.native.prevent>
          <form-item label="是否通过" prop="status">
            <RadioGroup v-model="formInfo.status">
              <Radio :label="1" class="radio">通过</Radio>
              <Radio :label="2">不通过</Radio>
            </RadioGroup>
          </form-item>
          <form-item label="拒绝理由" prop="remark"  v-if="formInfo.status==2">
            <Input placeholder="请输入" v-model="formInfo.remark"></Input>
          </form-item>
        </Form>
    </div>
    <div slot="footer">
        <Button type="primary"   @click="handleOk('formInfo')">确定</Button>
    </div>
  </Modal>
</template>
<style scoped>
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }
</style>
<script>
// import { updateComment } from '@/api/homestay/commentReply'
export default {
  name: 'refundEdit',
  data () {
    return {
      isShow: false,
      formInfo: {
        comm_list_id: 0,
        status: 1,
        remark: ''
      },
      ruleValidate: {
      }
    }
  },
  created () {
  },
  methods: {
    handle (status) {
      this.isShow = false
    },
    handleOk (name) {
      if (this.formInfo.status === 2 && (this.formInfo.remark === '' || this.formInfo.remark === null)) {
        this.$Message.error('拒绝理由必填')
        return
      }
      this.$refs[name].validate(valid => {
        if (valid) {
          // updateComment(this.formInfo).then(res => {
          //   this.$Message.success('提交成功')
          //   this.$emit('updateStatus')
          // }).catch(res => {
          //   this.$Message.error(res.msg)
          // })
          this.isShow = false
        }
      })
    }
  }
}
</script>
